module.exports = __webpack_public_path__ + "static/media/messagebird.5d452e6e.svg";